// src/features/tidsregistering/hooks/useAbsences.js
import { useState, useCallback } from 'react';
import { absencesAPI } from '../services/absences';
import { useApi } from '../../../hooks/api/useApi';

export function useAbsences() {
  const [absence, setAbsence] = useState(null);
  const [absences, setAbsences] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchAbsence = useCallback(async (absenceId) => {
    const result = await execute(() => absencesAPI.getAbsence(absenceId));
    if (result.success) setAbsence(result.data ?? null);
    return result;
  }, [execute]);

  const fetchForStaff = useCallback(async (staffMemberId, startDate, endDate) => {
    const result = await execute(() => absencesAPI.listForStaff(staffMemberId, startDate, endDate));
    if (result.success) setAbsences(result.data?.absences ?? []);
    return result;
  }, [execute]);

  const fetchForDepartment = useCallback(async (startDate, endDate) => {
    const result = await execute(() => absencesAPI.listForDepartment(startDate, endDate));
    if (result.success) setAbsences(result.data?.absences ?? []);
    return result;
  }, [execute]);

  const createAbsence = useCallback(async (data) => {
    const result = await execute(() => absencesAPI.createAbsence(data));
    if (result.success) setAbsence(result.data ?? null);
    return result;
  }, [execute]);

  const approveAbsence = useCallback(async (absenceId, data) => {
    const result = await execute(() => absencesAPI.approveAbsence(absenceId, data));
    if (result.success) setAbsence(result.data ?? null);
    return result;
  }, [execute]);

  const rejectAbsence = useCallback(async (absenceId, data) => {
    const result = await execute(() => absencesAPI.rejectAbsence(absenceId, data));
    if (result.success) setAbsence(result.data ?? null);
    return result;
  }, [execute]);

  const updateAbsenceDates = useCallback(async (absenceId, data) => {
    const result = await execute(() => absencesAPI.updateAbsenceDates(absenceId, data));
    if (result.success) setAbsence(result.data ?? null);
    return result;
  }, [execute]);

  const closeOpenEndedAbsence = useCallback(async (absenceId, data) => {
    const result = await execute(() => absencesAPI.closeOpenEndedAbsence(absenceId, data));
    if (result.success) setAbsence(result.data ?? null);
    return result;
  }, [execute]);

  const deleteAbsence = useCallback(async (absenceId) => {
    const result = await execute(() => absencesAPI.deleteAbsence(absenceId));
    if (result.success) setAbsence(null);
    return result;
  }, [execute]);

  const addComment = useCallback(async (absenceId, data) => {
    return execute(() => absencesAPI.addComment(absenceId, data));
  }, [execute]);

  return {
    absence,
    absences,
    loading,
    error,
    clearError,
    fetchAbsence,
    fetchForStaff,
    fetchForDepartment,
    createAbsence,
    approveAbsence,
    rejectAbsence,
    updateAbsenceDates,
    closeOpenEndedAbsence,
    deleteAbsence,
    addComment,
  };
}
